import { z } from "zod";

export const connectDevicesToProviderPayloadSchema = z.object({
  data: z.array(
    z.object({
      vehicleUuid: z.uuid(),
      vin: z.string(),
      registrationNumber: z.string(),
      companyUuid: z.uuid(),
      departmentUuid: z.uuid().nullable().optional(),
      deviceId: z.string(),
      brand: z.string().nullable(),
      updatedBy: z.string(),
    }),
  ),
});

export type ConnectDevicesToProviderPayload = z.infer<
  typeof connectDevicesToProviderPayloadSchema
>;
